// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global CSS Fixes for Wasted Space */

/* Fix all container elements to use full width */
.container,
.container-fluid,
.wrapper,
.main-container,
.content-container,
.dashboard-container,
.page-container {
  max-width: 100% !important;
  width: 100% !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}

/* Fix table containers */
.table-container,
.table-wrapper,
.data-table-container {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0.5rem !important;
}

/* Fix form containers */
.form-container,
.create-form-container,
.edit-form-container {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0.5rem !important;
}

/* Fix card containers */
.card-container,
.info-card-container,
.detail-card-container {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0.5rem !important;
}

/* Fix modal containers */
.modal-container,
.dialog-container,
.popup-container {
  max-width: 95vw !important;
  width: 95vw !important;
  margin: 0 auto !important;
}

/* Fix grid layouts */
.grid-container,
.flex-container,
.layout-container {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0.5rem !important;
}

/* Fix sidebar and main content areas */
.main-content,
.content-area,
.page-content {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0.5rem !important;
}

/* Fix specific page containers */
.create-compliance-container,
.user-management-container,
.compliance-container,
.risk-container,
.assessment-container {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0.5rem !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .container,
  .container-fluid,
  .wrapper,
  .main-container,
  .content-container,
  .dashboard-container,
  .page-container,
  .table-container,
  .table-wrapper,
  .data-table-container,
  .form-container,
  .create-form-container,
  .edit-form-container,
  .card-container,
  .info-card-container,
  .detail-card-container,
  .grid-container,
  .flex-container,
  .layout-container,
  .main-content,
  .content-area,
  .page-content,
  .create-compliance-container,
  .user-management-container,
  .compliance-container,
  .risk-container,
  .assessment-container {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }
}

@media (max-width: 480px) {
  .container,
  .container-fluid,
  .wrapper,
  .main-container,
  .content-container,
  .dashboard-container,
  .page-container,
  .table-container,
  .table-wrapper,
  .data-table-container,
  .form-container,
  .create-form-container,
  .edit-form-container,
  .card-container,
  .info-card-container,
  .detail-card-container,
  .grid-container,
  .flex-container,
  .layout-container,
  .main-content,
  .content-area,
  .page-content,
  .create-compliance-container,
  .user-management-container,
  .compliance-container,
  .risk-container,
  .assessment-container {
    padding-left: 0.125rem !important;
    padding-right: 0.125rem !important;
  }
}

/* Override Bootstrap container classes if present */
@media (min-width: 576px) {
  .container {
    max-width: 100% !important;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 100% !important;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 100% !important;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 100% !important;
  }
}

@media (min-width: 1400px) {
  .container {
    max-width: 100% !important;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/global-fixes.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC,iDAAiD;AACjD;;;;;;;EAOE,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;;;EAGE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;;;EAGE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;;;EAGE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;;;EAGE,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;;;EAGE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,uCAAuC;AACvC;;;EAGE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;;;;;EAKE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE;;;;;;;;;;;;;;;;;;;;;;;;;;;IA2BE,gCAAgC;IAChC,iCAAiC;EACnC;AACF;;AAEA;EACE;;;;;;;;;;;;;;;;;;;;;;;;;;;IA2BE,iCAAiC;IACjC,kCAAkC;EACpC;AACF;;AAEA,oDAAoD;AACpD;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Global CSS Fixes for Wasted Space */\n\n/* Fix all container elements to use full width */\n.container,\n.container-fluid,\n.wrapper,\n.main-container,\n.content-container,\n.dashboard-container,\n.page-container {\n  max-width: 100% !important;\n  width: 100% !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  padding-left: 0.5rem !important;\n  padding-right: 0.5rem !important;\n}\n\n/* Fix table containers */\n.table-container,\n.table-wrapper,\n.data-table-container {\n  max-width: 100% !important;\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 0.5rem !important;\n}\n\n/* Fix form containers */\n.form-container,\n.create-form-container,\n.edit-form-container {\n  max-width: 100% !important;\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 0.5rem !important;\n}\n\n/* Fix card containers */\n.card-container,\n.info-card-container,\n.detail-card-container {\n  max-width: 100% !important;\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 0.5rem !important;\n}\n\n/* Fix modal containers */\n.modal-container,\n.dialog-container,\n.popup-container {\n  max-width: 95vw !important;\n  width: 95vw !important;\n  margin: 0 auto !important;\n}\n\n/* Fix grid layouts */\n.grid-container,\n.flex-container,\n.layout-container {\n  max-width: 100% !important;\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 0.5rem !important;\n}\n\n/* Fix sidebar and main content areas */\n.main-content,\n.content-area,\n.page-content {\n  max-width: 100% !important;\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 0.5rem !important;\n}\n\n/* Fix specific page containers */\n.create-compliance-container,\n.user-management-container,\n.compliance-container,\n.risk-container,\n.assessment-container {\n  max-width: 100% !important;\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 0.5rem !important;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .container,\n  .container-fluid,\n  .wrapper,\n  .main-container,\n  .content-container,\n  .dashboard-container,\n  .page-container,\n  .table-container,\n  .table-wrapper,\n  .data-table-container,\n  .form-container,\n  .create-form-container,\n  .edit-form-container,\n  .card-container,\n  .info-card-container,\n  .detail-card-container,\n  .grid-container,\n  .flex-container,\n  .layout-container,\n  .main-content,\n  .content-area,\n  .page-content,\n  .create-compliance-container,\n  .user-management-container,\n  .compliance-container,\n  .risk-container,\n  .assessment-container {\n    padding-left: 0.25rem !important;\n    padding-right: 0.25rem !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .container,\n  .container-fluid,\n  .wrapper,\n  .main-container,\n  .content-container,\n  .dashboard-container,\n  .page-container,\n  .table-container,\n  .table-wrapper,\n  .data-table-container,\n  .form-container,\n  .create-form-container,\n  .edit-form-container,\n  .card-container,\n  .info-card-container,\n  .detail-card-container,\n  .grid-container,\n  .flex-container,\n  .layout-container,\n  .main-content,\n  .content-area,\n  .page-content,\n  .create-compliance-container,\n  .user-management-container,\n  .compliance-container,\n  .risk-container,\n  .assessment-container {\n    padding-left: 0.125rem !important;\n    padding-right: 0.125rem !important;\n  }\n}\n\n/* Override Bootstrap container classes if present */\n@media (min-width: 576px) {\n  .container {\n    max-width: 100% !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .container {\n    max-width: 100% !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .container {\n    max-width: 100% !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .container {\n    max-width: 100% !important;\n  }\n}\n\n@media (min-width: 1400px) {\n  .container {\n    max-width: 100% !important;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
